<template>
  <div class="direct-document">
    <h1>
      <span>{{ direct.organization__name }}</span>
    </h1>
    <table class="bordered">
      <tr>
        <td>3425</td>
        <td><span class="bold">{{ $t('interface.registerCard') }}</span></td>
        <td><span class="bold">{{ $t('direct.question') }}</span></td>
      </tr>
      <tr>
        <td colspan="3">
          <p class="bold">
            {{ $t('docflow.fields.applicant_name') }}: {{direct.applicant_name}} {{direct.applicant_company_name}}
          </p>
          <p>
            <span class="bold">{{ $t('docflow.fields.applicant_address') }}:</span>
            {{direct.applicant_address}}, {{direct.applicant_region__name}}, {{direct.applicant_area__name}}
          </p>
          <p>
            <span class="bold">{{ $t('docflow.fields.applicant_mobile_phone') }}:</span>
            {{direct.applicant_mobile_phone}} {{direct.applicant_work_phone}}
          </p>
        </td>
      </tr>
      <tr>
        <td colspan="3">
          <p>
            <span class="bold">{{ $t('docflow.fields.type') }}:</span>
            {{direct.type__name}}
          </p>
          <p>
            <span class="bold">{{ $t('direct.mail_date_index') }}:</span>
            {{ direct.sender__name }} № {{ direct.original_document_number }} {{ direct.original_document_date | date }}
          </p>
          <p>
            <span class="bold">{{ $t('direct.registration_date_index') }}:</span>
            №{{ direct.registration_number }} {{ direct.registered_date | date }}
          </p>
          <p>
            <span class="bold">{{ $t('direct.control_type') }}:</span>
          </p>
        </td>
      </tr>
      <tr>
        <td colspan="3">
          <span class="bold">{{ $t('interface.description') }}:</span><br>
          {{ direct.description }}
        </td>
      </tr>
      <tr>
        <td><span class="bold">{{ $t('documents.executor') }}</span></td>
        <td colspan="2">
          {{ direct.resolution_maintainer__initials }}, {{ $t('documents.fields.term') }}: {{ direct.term_date | date }}
        </td>
      </tr>
      <tr>
        <td><span class="bold">{{ $t('docflow.fields.supervisor') }}</span></td>
        <td colspan="2">
          {{ direct.supervisor__post_name }} - {{ direct.supervisor__initials }}
        </td>
      </tr>
      <tr>
        <td colspan="3">
          <span class="bold">{{ $t('docflow.resolution') }}:</span><br>
          <ul>
            <li v-for="task in direct.resolution_tasks">
              {{ task.employee.fullname }}: {{ task.description }},
              {{ $t('direct.term') }} {{task.term_date | date}}
            </li>
          </ul>
        </td>
      </tr>
      <tr>
        <td colspan="3">
          <p class="w50">{{ direct.resolution_approver__post_name }}</p>
          <p class="w50">{{ direct.resolution_approver__initials }}</p>
        </td>
      </tr>
      <tr>
        <td colspan="3">
          <p class="w50">
            <span class="bold">{{ $t('documents.fields.term') }}:</span> {{ direct.resolution_term_date | date }}
          </p>
          <p class="w50">
            <span class="bold">{{ $t('direct.doneDay') }}:</span>
          </p>
        </td>
      </tr>
      <tr>
        <td colspan="3">
          <span class="bold">{{$t('tasks.state')}}:</span>
          <ul>
            <li v-for="item in direct.states">
              {{ $t(`workflow.states.${item.state}`) }} &ndash;
              {{ item.created_at | dateTime }}
            </li>
          </ul>
        </td>
      </tr>
    </table>

    <table class="bordered mt-60">
      <tr>
        <td colspan="3" class="bold ttu tac">{{ $t('direct.progress') }}</td>
      </tr>
      <tr>
        <td class="bold">{{ $t('direct.progress_date') }}</td>
        <td class="bold">{{ $t('direct.sent_to') }}</td>
        <td class="bold">{{ $t('direct.control_sign') }}</td>
      </tr>
      <tr v-for="n in 6">
        <td v-for="n in 3">&nbsp;</td>
      </tr>
      <tr>
        <td colspan="3">
          <span class="bold">{{ $t('direct.receiver_and_date') }}</span>,<br>
          <span class="bold">{{ $t('direct.progress_index') }}</span>
        </td>
      </tr>
      <tr>
        <td colspan="3">
          <span class="bold">{{ $t('interface.description') }}</span><br><br><br><br>
        </td>
      </tr>
      <tr>
        <td colspan="3">
          <p class="w50 bold">
            {{ $t('direct.removed_from_control') }}<br>
            {{ $t('interface.date') }}:
          </p>
          <p class="w50 bold">
            {{ $t('direct.executor_sign') }}<br>
            {{ $t('interface.date') }}:
          </p>
        </td>
      </tr>
      <tr>
        <td colspan="3">
          <span class="bold">{{ $t('direct.control') }}:</span> {{ $t('direct.no') }}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import {priorityColors, stateColors} from '@/colorTypes'
  import Timeline from '@/components/Timeline'
  import Attachments from '@/components/Attachments'
  import Correspondents from '@/components/Correspondents'

  export default {
    components: {Timeline, Attachments, Correspondents},
    data() {
      return {
        stateColors
      }
    },
    computed: {
      ...mapState('Docflow', ['direct'])
    }
  }
</script>

<style lang="scss" scoped>
  .direct-document {
    font-size: 16px;
    line-height: 28px;

    .tac {
      text-align: center;
    }

    .ttu {
      text-transform: uppercase;
    }

    .w50 {
      width: 50%;
      display: inline-block;
    }

    h1 {
      font-size: 20px;
      text-align: center;
      font-weight: bold;
      margin-bottom: 30px;

      .sub {
        font-size: 16px;
      }
    }
    table {
      width: 100%;
      margin-bottom: 20px;

      &.bordered {
        margin-top: 10px;
        font-size: 14px;
        td {
          padding: 5px 10px;
          border: 1px solid #333;
        }
      }

      tr {
        td:first-child {
          padding-right: 20px;
        }
      }
    }
    .bold {
      font-weight: bold;
    }
    .underline {
      text-decoration: underline;
    }
    ul {
      list-style: disc;
      li {
        margin-left: 18px;
      }
    }
  }
</style>
